import React, { useEffect, useRef, useCallback, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Stack } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  editedMessageTextSuccess,
  editMessage,
  fetchMessagesRequest,
  newMessageReceived,
} from "../../../../Store/Buzzcom/actions"; // Assuming you have this action in place
import _ from "lodash"; // For debouncing
import { Avatar } from "antd";
import { Modal } from "react-bootstrap";
import { getSocket } from "../../../../services/socketService";
import apiServices from "../../../../services/apiServices";

const ChatMessages = React.memo(() => {
  const dispatch = useDispatch();
  const getNewMessage = useSelector((state) => state.Buzzcom.newMessage); // Get messages from Redux
  const selectedChat = useSelector((state) => state.Buzzcom.selectedChat); // Get selected chat
  const editedMessageText = useSelector(
    (state) => state.Buzzcom.editedMessageText
  );
  const conversationId = selectedChat && selectedChat?.conversationId;
  const [currentPage, setCurrentPage] = useState(1);
  const sender = selectedChat ? selectedChat?.conversationId.split(".")[0] : "";
  const receiver = selectedChat
    ? selectedChat?.conversationId.split(".")[1]
    : "";
  const messageListRef = useRef(null);
  const lastMessageRef = useRef(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [messages, setMessages] = useState([]);
  const [messageRefresh, setMessageRefresh] = useState(false);
  const [deletedMessageId, setDeletedMessageId] = useState();
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [lastRes, setLastRes] = useState([]);
  const [currentScrollOffset, setCurrentScrollOffset] = useState(null);
  const [imageModal, setImageModal] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const [hideEdit, setHideEdit] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 }); // Position for the menu
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Menu visibility
  const isMenuOpenRef = useRef(isMenuOpen);
  const menuRef = useRef(null);
  const messagesRef = useRef(messages);
  const debounceTimeoutRef = useRef(null);
  // Local state for pagination
  const socket = getSocket();

  // // Fetch initial messages
  // useEffect(() => {
  //   if (conversationId) {
  //     dispatch(fetchMessagesRequest(conversationId, 1));
  //   }
  // }, [conversationId, dispatch]);

  // Throttled function to load more messages when scrolling to top

  // Methods
  const callMessagesApi = async (page) => {
    try {
      console.log(page);
      if (isFetching) return;
      setIsFetching(true);
      let response = await apiServices.getAllMessages(
        selectedChat?.conversationId,
        page
      );
      const data = Array.isArray(response?.data) ? response?.data : [];
      setIsFetching(false);
      if (data?.length === 0) {
        return;
      } else {
        page === 1
          ? setMessages(data)
          : setMessages((prevMessages) => [...data, ...(prevMessages || [])]);
        // setLastRes(response);
      }
    } catch (err) {
      console.error("Error fetching messages:", err);
    }
  };

  const loadMoreMessages = useCallback(
    _.throttle(() => {
      setCurrentPage((prev) => (prev += 1));
    }, 1000),
    []
  );

  const zoomImage = (e) => {
    setImageModal(true);
    setImageUrl(e);
  };
  // useEffect(() => {
  //   setMessages((prev) => [...prev, getNewMessage]);
  // }, [getNewMessage]);

  // Scroll handler with throttling
  const handleScroll = () => {
    if (!messageListRef.current) return;
    const { scrollTop, scrollHeight } = messageListRef.current;
    console.log("HANDLESCROLLCHANGE", scrollTop);

    if (isMenuOpenRef.current) {
      //If menu Open and scroll changes close it
      setIsMenuOpen(false);
    }
    if (scrollTop === 0) {
      setCurrentScrollOffset(scrollHeight - scrollTop);
      loadMoreMessages();
    }
  };

  // function splitTextIntoLines(text, maxCharsPerLine) {
  //   if (text?.length <= maxCharsPerLine) {
  //     return <p>{text}</p>;
  //   }

  //   const lines = [];
  //   let remainingText = text;

  //   while (remainingText?.length > 0) {
  //     lines.push(remainingText.substring(0, maxCharsPerLine));
  //     remainingText = remainingText.substring(maxCharsPerLine);
  //   }

  //   return lines.map((line, index) => <p key={index}>{line}</p>);
  // }

  const renderMediaContent = (text) => {
    const isImageURL = /\.(gif|jpe?g|tiff?|png|webp|bmp)-\d+(\?.*)?$/i.test(
      text
    );
    const isVideoURL = /\.(mp4|webm|MOV|ogg)-\d+(\?.*)?$/i.test(text);
    const isAudioURL = /\.(mp3|wav)-\d+(\?.*)?$/i.test(text);
    const isFileURL = /\/[^/.]+\.\w+-\d+(\?.*)?$/i.test(text);

    const handleImageClick = () => {
      const anchor = document.createElement("a");
      anchor.href = text;
      anchor.download = text.split("/").pop();
      anchor.click();
    };

    if (isImageURL) {
      return (
        <img
          style={{ width: "100%", height: "120px", borderRadius: "10px" }}
          src={text}
          alt="Image"
          onClick={(e) => zoomImage(text)}
        />
      );
    } else if (isVideoURL) {
      return (
        <video controls style={{ width: "200px", height: "120px" }}>
          <source src={text} />
          Your browser does not support the video tag.
        </video>
      );
    } else if (isAudioURL) {
      return (
        <audio controls src={text}>
          Your browser does not support the audio tag.
        </audio>

        // </audio>
        //   <audio controls>
        //     <source src={text} type={`audio/${text.split(".").pop()}`} />
        //     Your browser does not support the audio tag.
        //   </audio>
      );
    } else if (isFileURL) {
      return (
        <div>
          <img
            style={{ width: "100%", height: "80px", borderRadius: "10px" }}
            onClick={handleImageClick}
            src={
              process.env.REACT_APP_PUBLIC_URL +
              "/BuzzCom/images/filesample.jpg"
            }
            alt="File Thumbnail"
          />
          {/* <a href={text} download={text.split('/').pop()}>{text.split('/').pop()}</a>
        <p>File - {text.split('.').pop()}</p> */}
        </div>
      );
    } else {
      return (
        <div style={{ lineHeight: "20px" }}>
          {text?.length > 80 ? (
            <div>
              {text.substring(0, 80)}
              <br />
              {Array.from(
                { length: Math.ceil((text?.length - 80) / 80) },
                (_, index) => (
                  <div key={index}>
                    {text.substring(80 + index * 80, 80 + (index + 1) * 80)}
                    <br />
                  </div>
                )
              )}
            </div>
          ) : (
            text
          )}
        </div>
      );
    }
  };
  const isURL = (text) => {
    const urlPattern =
      /^(?:https?|ftp):\/\/(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/;
    return urlPattern.test(text);
  };
  // Handle more actions (edit, delete, etc.)
  const handleClick = (event, message) => {
    event.preventDefault();
    const rect = event.currentTarget.getBoundingClientRect();

    setMenuPosition({ top: rect.bottom, left: rect.left });
    setHideEdit(false);
    if (isURL(message.text)) {
      // It's a URL!
      setHideEdit(true);
    }
    setSelectedMessage(message);
    setIsMenuOpen(true);
  };

  const handleEdit = () => {
    try {
      console.log("edit1SelectedMessage", selectedMessage);
      selectedMessage && dispatch(editMessage(selectedMessage));
      setIsMenuOpen(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDelete = async (id) => {
    console.log("selectedMessage9", id);

    try {
      let response = await apiServices.deleteMessage(id);
      console.log("response delete", response);

      socket.emit("MessageDelete", { messageId: id }, (res) =>
        console.log("del is", res)
      );
      setDeletedMessageId(id);
      setMessageRefresh(!messageRefresh);
      setIsMenuOpen(false);
      setSelectedMessage(null);
    } catch (err) {
      console.log("handle Delete Error", err);
    }
  };

  const callSeenApi = async () => {
    await apiServices.seenMessages(selectedChat?.conversationId, sender);
  };

  // ----------------------------- EFFECT HOOKS -----------------------------
  useEffect(() => {
    console.log("CallMessage", selectedChat);
    setCurrentPage(1);
    callMessagesApi(1);
    callSeenApi();
  }, [selectedChat, messageRefresh]);

  useEffect(() => {
    if (currentPage !== 1) callMessagesApi(currentPage);
    // callSeenApi();
  }, [currentPage, deletedMessageId]);

  useEffect(() => {
    if (getNewMessage) {
      setMessages((prev) => [...prev, getNewMessage]);
      messageListRef.current.scrollTop = messageListRef.current.scrollHeight;
    }
    // Debounce call to fetch messages from the server
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current); // Clear previous timeout
    }

    debounceTimeoutRef.current = setTimeout(() => {
      setCurrentPage(1);
      callMessagesApi(1);
    }, 1500); // Adjust debounce delay as needed

    // Cleanup
    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current); // Clear timeout on component unmount
      }
    };
  }, [getNewMessage]);

  useEffect(() => {
    if (currentPage === 1) {
      messageListRef.current.scrollTop = messageListRef.current.scrollHeight;
    }

    if (messageListRef?.current?.scrollTop === 0 && currentPage >= 1) {
      messageListRef.current.scrollTop =
        messageListRef.current.scrollHeight - currentScrollOffset;
    }
    console.log(
      "SCROLEHEIGHTATCHANGE",
      currentScrollOffset,
      messageListRef.current.clientHeight,
      messageListRef.current.scrollHeight
    );
  }, [messages]);

  useEffect(() => {
    messagesRef.current = messages;
  }, [messages]);

  // Edit Message Update to existing message
  useEffect(() => {
    if (editedMessageText) {
      const updatedMessages = messages.map((message) =>
        message._id === selectedMessage._id
          ? { ...message, text: editedMessageText }
          : message
      );
      setMessages(updatedMessages);
      setSelectedMessage(null);
      dispatch(editMessage(null));
      dispatch(editedMessageTextSuccess(null));
    }

    return () => {
      dispatch(editMessage(null));
      dispatch(editedMessageTextSuccess(null));
    };
  }, [editedMessageText]);
  // Handle click outside to close the menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
        setSelectedMessage(null);
      }
    };

    // Add event listener when menu is open
    if (isMenuOpen) {
      document.addEventListener("click", handleClickOutside);
    }

    // Cleanup the event listener
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isMenuOpen]);

  // Get the Ref of Edit Delete Menu OPEN = true || false
  useEffect(() => {
    isMenuOpenRef.current = isMenuOpen;
  }, [isMenuOpen]);

  useEffect(() => {
    if (messageListRef.current) {
      messageListRef.current.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (messageListRef.current) {
        messageListRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    // Handle WebSocket events here

    socket.on("ios_prv_message", (message) => {
      console.log("Received message:", message);
      message.updatedAt = new Date().toISOString();
      // setChatting(true);
      setMessages((prevMessage) => [...prevMessage, message]);
      // Update the UI with the message
      // You can use the payload properties here to update the UI as needed
    });
    // socket.on("contactsRefresh");

    socket.on("messageEdit", (message) => {
      console.log("edit msg", message);

      if (!message.conversationId) return;
      if (
        message?.conversationId === selectedChat?.conversationId ||
        message?.conversationId ===
          selectedChat?.conversationId.split(".").reverse().join(".")
      ) {
        const updatedMessages = messagesRef.current?.map((__message) =>
          __message._id === message._id
            ? { ...__message, text: message.text }
            : __message
        );
        setMessages(updatedMessages);
      }
      console.log("MessageEdit successfully!", message);
    });

    socket.on("MessageDelete", (message) => {
      console.log("msg9", message);

      // if (!message.conversationId) return;
      // if (
      //   message?.conversationId === selectedChat?.conversationId ||
      //   message?.conversationId ===
      //     selectedChat?.conversationId.split(".").reverse().join(".")
      // ) {
      console.log("del res is", message);
      const updatedMessages = messagesRef.current?.filter(
        (__message) => __message._id !== message.messageId
      );
      setMessages(updatedMessages);
      // }
      console.log("MessageEdit successfully!", message);
    });

    // Clean up the event listeners when the component unmounts
    return () => {
      socket.off("prv_typing_message");
      socket.off("ios_prv_message");
      socket.off("messageEdit");
      socket.off("MessageDelete");
    };
  }, []);

  // Method to render media or text in a message
  // const renderMediaContent = (content) => {
  //   if (content.startsWith("http")) {
  //     return (
  //       <img src={content} alt="Media content" style={{ maxWidth: "100%" }} />
  //     );
  //   } else {
  //     return <p>{content}</p>;
  //   }
  // };

  console.log("msgt", messages);

  return (
    <div className="message-list" ref={messageListRef}>
      {messages?.length > 1 &&
        messages
          .filter((message) => {
            const conversationIds = [
              `${sender}.${receiver}`,
              `${receiver}.${sender}`,
            ];
            return conversationIds.includes(message.conversationId);
          })
          // ?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
          ?.map((message, index) => (
            <div
              ref={index === messages?.length - 1 ? lastMessageRef : null}
              key={message._id}
              className={`message ${
                message.from === sender ? "custom-message" : "message"
              } ${message.from === receiver ? "incoming1" : ""} ${
                message.from === sender ? "color: #ff6500" : "#ec3e4c"
              }`}
              style={{
                backgroundColor: "none",
                borderBottom: "0px",
                color: "black",
              }}
            >
              {/* {message.from === receiver && (
                <Stack
                  style={{ position: "relative", top: "-38%" }}
                  direction="row"
                  spacing={2}
                >
                  <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg">
                  {" "}
                  {selectedChat?.contacts[1].userName.charAt(0)}
                </Avatar>
                </Stack>
              )} */}

              <div>
                <p
                  className={
                    message.from == sender
                      ? "custom-message-time"
                      : "message-time"
                  }
                >
                  {`${new Date(message.updatedAt).toLocaleTimeString([], {
                    hour: "numeric",
                    minute: "2-digit",
                  })}, ${new Date(message.updatedAt).toLocaleDateString([], {
                    day: "numeric",
                    month: "short",
                  })}`}
                </p>

                <div
                  onContextMenu={(e) => e.preventDefault()}
                  className={`message ${
                    message.from == sender
                      ? "custom-outgoing-message"
                      : "incoming"
                  }`}
                >
                  {" "}
                  <div
                    className={`custom-message-text ${
                      message.from == sender ? "" : "message-text"
                    }`}
                  >
                    {renderMediaContent(message.text)}

                    {/* {splitTextIntoLines(renderMessageWithLinks(message.text), 30)} */}
                    {/* <p>{renderMessageWithLinks(message.text)}</p> */}
                  </div>
                  {message.from == sender && (
                    <div class="dropdown show chat-edit-del">
                      <div
                        class="dropdown-toggle"
                        id="dropdownMenuLink"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <MoreVertIcon
                          className="iconColor"
                          onClick={(e) => {
                            handleClick(e, message); // Trigger context menu manually
                          }}
                        />
                      </div>

                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuLink"
                      >
                        <button className="dropdown-item" onClick={handleEdit}>
                          Edit
                        </button>
                        <button
                          className="dropdown-item"
                          onClick={() => handleDelete(message._id)}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
      {/* {isMenuOpen && (
        <div
          ref={menuRef}
          className="dropdown-menu show"
          style={{
            position: "absolute",
            top: menuPosition.top,
            left: menuPosition.left,
            minWidth: "70px", // Automatically adjust width based on content
            whiteSpace: "nowrap", // Prevent text from wrapping
            overflow: "hidden", // Avoid visible overflow
            zIndex: 1050, // Ensure menu stays on top
          }}
        >
          {!hideEdit && (
            <button className="dropdown-item" onClick={handleEdit}>
              Edit
            </button>
          )}
          <button className="dropdown-item" onClick={handleDelete}>
            Delete
          </button>
        </div>
      )} */}
      <div>
        <Modal
          open={imageModal}
          onClose={() => {
            setImageModal(false);
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <img
              style={{
                width: "500px",
                height: "300px",
                borderRadius: "10px",
                transition: "width 0.5s, height 0.5s, border-radius 0.5s",
                cursor: "pointer",
              }}
              src={imageUrl}
              alt="Image"
              onClick={() => setImageModal(false)}
            />
          </div>
        </Modal>
      </div>
    </div>
  );
});

export default ChatMessages;
